import React from 'react';

import './question-answer.scss';

const images = require.context('../../Assets/emoji', true);

const userFreeTypes = [
  'text',
  'textarea',
  'date',
  'phone',
  'number',
  'radiobutton',
];
const multiAnswer = ['checkbox'];

const QuestionAnswer = ({ profile_questions = [] }) => {
  const getAnswer = (question) => {
    if (!question.answer) return '';
    if (userFreeTypes.includes(question.question_type))
      return (
        <div className="single_line">{question.answer[0].answer_text}</div>
      );
    if (multiAnswer.includes(question.question_type))
      return (
        <div className="multi_line">
          <ul>
            {question.answer.map((q, i) => (
              <li key={i}>{q.answer_text}</li>
            ))}
          </ul>
        </div>
      );
    if (question.question_type === 'emoji')
      return (
        <div className="emoji">
          <img
            src={images(`./${question.answer[0].emoji_code}.svg`)}
            alt="emoji"
          />
        </div>
      );
  };

  const profileQuestions = profile_questions.filter((q) => q.answer);

  if (!profileQuestions.length) return null;
  return (
    <div className="question-answer">
      <div className="profile-title">Get to know me!</div>
      {profileQuestions.map((question, index) => (
        <div key={index} className="question-details">
          <div className="question">
            {index + 1}. {question.text}
          </div>
          <div className="answer">answer: {getAnswer(question)}</div>
        </div>
      ))}
    </div>
  );
};

export default QuestionAnswer;
